import { useEffect } from 'react';
import { useSettings } from './store/settings';
import { useRoute } from './lib/runtime';
import { TopNav } from './components/TopNav';
import { StatusBar } from './components/StatusBar';
import { FeedPanel } from './components/FeedPanel';
import { TrackedPanel } from './components/TrackedPanel';
import { Resizer } from './components/Resizer';
import { Pulse } from './views/Pulse';
import { TokenView } from './views/TokenView';
import { Discover } from './views/Discover';
import { Trackers } from './views/Trackers';
import { Portfolio } from './views/Portfolio';
import { Rankings } from './views/Rankings';
import { Train } from './views/Train';
import { RoomView } from './views/Room';
import { DevScenarios } from './views/DevScenarios';
import { Modals } from './components/Modals';
import { InstantTrade } from './components/InstantTrade';
import { RoundStrip, ResultsModal } from './components/RoundHud';
import { Toasts } from './components/Toasts';

export function App() {
  const route = useRoute((s) => s.route);
  const { feedSide, feedWidth, feedOpen, trackedOpen, reducedMotion } = useSettings();
  useEffect(() => { document.documentElement.classList.toggle('reduce-motion', reducedMotion); }, [reducedMotion]);
  const view = route.view === 'token' ? <TokenView key={route.id} id={route.id} /> : route.view === 'room' ? <RoomView code={route.code} /> : route.view === 'dev' ? <DevScenarios /> :
    route.view === 'discover' ? <Discover /> : route.view === 'trackers' ? <Trackers /> : route.view === 'portfolio' ? <Portfolio /> : route.view === 'rankings' ? <Rankings /> : route.view === 'train' ? <Train /> : <Pulse />;
  const feed = feedOpen && <div className="dock feed-dock" style={{ width: feedWidth }}><FeedPanel /></div>;
  return <div className="app">
    <TopNav />
    <RoundStrip />
    <div className="main">
      {feedSide === 'left' && feed}{feedSide === 'left' && feedOpen && <Resizer side="left" />}
      <main className="content">{view}</main>
      {feedSide === 'right' && feedOpen && <Resizer side="right" />}{feedSide === 'right' && feed}
      {trackedOpen && <TrackedPanel />}
    </div>
    <StatusBar />
    <InstantTrade />
    <ResultsModal />
    <Modals />
    <Toasts />
  </div>;
}
